<!--

============================================================================================================
||    FlowTrigger page                                                                                    ||
============================================================================================================

|   Description
------------------------------------------------------------------------------------------------------------
  Second page in flow wizard. User selects a trigger that will start the flow.


|   Events - page should not emit events
------------------------------------------------------------------------------------------------------------
  - input       : Object    : Emits object with valid and selected parameters.

-->

<template>
  <div class="flow-trigger-step">
    <h2>Select a trigger that will start this AI flow</h2>
    <!-- <pre class="debug"> {{ selected }}</pre> -->
    <p>Choose a trigger that will activate your flow.</p>
    <ValidationObserver ref="triggerObserver" >
      <ValidationProvider
        name="Name"
        rules="required">
        <BlockSelect
          v-if="triggerOptions && triggerOptions.length"
          v-model="selected"
          :options="triggerOptions"
          preselect-first
          prevent-empty />
      </ValidationProvider>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BlockSelect from '@/components/common/BlockSelect';

export default {
  name: 'FlowTriggerStep',
  components: {
    BlockSelect,
  },
  data() {
    return {
      selected: {},
    };
  },
  computed: {
    ...mapGetters({
      flowsDefinitions: 'flows/flowsDefinitions',
    }),
    triggerOptions() {
      try {
        const triggers = this.flowsDefinitions.blocks.definitions.triggers.map(trigger => ({
          id: trigger.definition.backend_structure.type,
          image: trigger.definition.icons.dark,
          title: trigger.meta.name,
          subtitle: trigger.meta.description,
        }));
        return triggers;
      } catch (error) {
        // console.error('Error getting trigger groups', error);
      }

      return [];
    },
  },
  watch: {
    selected: {
      handler() {
        if (!this.$refs.triggerObserver) return;
        this.$refs.triggerObserver.validate()
          .then((valid) => {
            this.$emit('input', {
              valid: valid && this.selected.valid,
              name: 'flowTrigger',
              data: { ...this.selected },
            });
          });
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.$refs.triggerObserver.validate()
      .then((valid) => {
        this.$emit('input', {
          valid: valid && this.selected.valid,
          name: 'flowTrigger',
          data: { ...this.selected },
        });
      })
      .finally(() => {
        try {
          if (this.$refs.triggerObserver) this.$refs.triggerObserver.reset();
        } catch (error) { }
      });
  },
};
</script>

<style lang="scss" scoped>
.flow-trigger-step {
  h2, p {
    text-align: center;
  }

  h2 {
    font-size: 18px;
    font-weight: bold;
    color: $blackPrimary;
    margin-bottom: 5px;
  }

  p {
    font-size: 14px;
    font-weight: normal;
    color: $blackUltralight;
    margin-bottom: 33px;
  }
}
</style>
